<template>
  <section>
    <Title :title-name="title.ServiceAcceptance.titleName" :title-link="title.ServiceAcceptance.titleLink" />
    <div class="service_acceptance">
      <div class="container">
        <!--MESSAGES-->
        <h2 class="title">Your Messages</h2>
        <div class="block-item row">
          <router-link class="col-12" :to="{ name: 'MessagesList', query: { secret: secret } }">
            <div class="row">
              <div class="item-icon col-2">
                <i class="sb_mobile sb_message text-right">
                  <i v-if="Cmtpax > 0" class="badge badge-pill badge-danger" style="font-size: 9pt">{{ Cmtpax }}</i>
                </i>
              </div>
              <div class="item-title col-9">Apologies for the in...</div>
              <div class="col-1 bullet_right"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
            </div>
          </router-link>
        </div>
        <!--/MESSAGES-->
        <!--FLIGHT-->
        <h2 class="title">Flight Information</h2>
        <div class="block-item row" style="margin-bottom: 15pt">
          <div class="container">
            <div class="row flightinfo text-center">
              <div class="col-4">
                <div>From</div>
                <div class="airport-name">{{ Flight.dep }}</div>
                <div class="flight-time-der">
                  <div>
                    <i class="fas fa-circle" style="color: rgb(7, 188, 236)"> </i>
                    {{ moment(Flight.std).format('hh:mm a') }}
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div>{{ Flight.carrier }}{{ Flight.flight_no }}</div>
                <div class="frame-flight-img" style="margin-top: 11pt">
                  <img src="@/assets/images/flight.png" />
                </div>
                <div class="flight-status">
                  <p style="color: #000">
                    Status: <span>{{ Flight.flight_status }}</span>
                  </p>
                </div>
              </div>
              <div class="col-4">
                <div>To</div>
                <div class="airport-name">{{ Flight.arr }}</div>
                <div class="flight-time-arr">
                  <div>
                    <i class="fas fa-circle" style="color: rgb(84, 206, 174)"> </i>
                    {{ moment(Flight.sta).format('hh:mm a') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block-item row">
          <router-link class="col-12" :to="{ name: 'PassengerDetail', query: { secret: secret } }">
            <div class="row">
              <div class="item-icon col-2">
                <i class="sb_mobile sb_flight_takeoff"></i>
              </div>
              <div class="item-title col-9">
                {{ pax.first_name }}
                {{ pax.last_name }}
                <span class="sub-title">PNR: {{ pax.pnr }} </span>
              </div>
              <div class="col-1 bullet_right"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
            </div>
          </router-link>
        </div>
        <!--/FLIGHT-->
        <!--SERVICES & VOUCHERS-->
        <div class="" style="margin: 14pt 0">
          <div class="block-item row">
            <div class="container" style="padding: 15px">
              1) Accommodation + transfer for tonight
              <div class="text-right" style="margin: 15pt 0">
                <router-link class="btnDefault" :to="{ name: 'Home', query: { secret: secret } }">Accept</router-link>
              </div>
            </div>
          </div>
          <div class="text-center" style="margin: 15pt 0">OR</div>
          <div class="block-item row">
            <div class="container" style="padding: 15px">
              2) Taxi back home* <small>(*maximum amount of 80 AUD)</small>
              <div class="text-right" style="margin: 15pt 0">
                <router-link class="btnDefault" :to="{ name: 'Home', query: { secret: secret } }">Accept</router-link>
              </div>
            </div>
          </div>
        </div>
        <!--/SERVICES & VOUCHERS-->
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/ServiceAcceptance.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'ServiceAcceptance',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: 'Home/Cmtpax',
      Flight: 'Flight/Flight'
    })
  },
  mounted() {
    this.$store.dispatch('Home/getCmtpax')
    this.$store.dispatch('Flight/getFlight')
    this.$store.dispatch('PaxContactDetail/updatePhoneNumber', { secret: this.secret })
  },
  methods: {}
}
</script>
